module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/zh-hans/4-f42124603b25f6a1769e6208a8a60b05.jpg";